var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/32px/twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/32px/twitter",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter-brands",
    transform: "translate(6.000000, 8.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8414213,4.23670332 C18.8547514,4.42263194 18.8547514,4.60860145 18.8547514,4.79453007 C18.8547514,10.4655983 14.5241817,17 6.60916058,17 C4.17069012,17 1.90547033,16.2960631 0,15.0742406 C0.346460338,15.1140591 0.679549529,15.1273456 1.03934,15.1273456 C3.05136934,15.1273456 4.90356017,14.4500225 6.3826304,13.2945505 C4.4904902,13.2546911 2.90481994,12.0195413 2.35848968,10.319529 C2.62501025,10.3593475 2.89148981,10.3859204 3.17134051,10.3859204 C3.55775023,10.3859204 3.94420095,10.3327746 4.30395041,10.2398512 C2.33187044,9.84138016 0.85275919,8.11483586 0.85275919,6.0296799 L0.85275919,5.97657496 C1.42570869,6.29532726 2.09201013,6.49454233 2.7981789,6.52107436 C1.63890875,5.75074609 0.879419451,4.4359184 0.879419451,2.94840767 C0.879419451,2.15154736 1.09257849,1.42107845 1.46569908,0.783573852 C3.58436947,3.38669719 6.76904011,5.08666857 10.3400795,5.27263808 C10.2734698,4.95388578 10.2334794,4.6218879 10.2334794,4.28984915 C10.2334794,1.92575937 12.1522799,0 14.5374298,0 C15.7766398,0 16.8959195,0.517967377 17.6821101,1.35468705 C18.6547994,1.16875843 19.5875394,0.810146764 20.4137204,0.3187523 C20.0938793,1.31486857 19.4143297,2.15158824 18.5215802,2.68280119 C19.3877105,2.58987776 20.2271806,2.35076244 21,2.01876456 C20.4138024,2.86872981 19.6808913,3.62573076 18.8414213,4.23670332 Z",
    id: "Path"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.afeaee83177fc93144756c3bf5e9a04c.svg";
export { ForwardRef as ReactComponent };